import { isUndefined, min } from 'lodash/fp';
import React, { useMemo } from 'react';

import { PieChart, PieChartAnalyticsData, PieColors } from '../../shared/analytics/PieChart';
import { Icon } from '../../shared/icon/Icon';
import styles from './Modules.module.scss';
import { MARKERS_HEIGHT } from '../../shared/carousel/Carousel';

const WRAPPER_PADDING = 20;

interface PieChartWrapperProps {
    data: PieChartAnalyticsData[];
    dimensions?: {
        height: number;
        width: number;
    }
    id?: string;
    testId?: string;
    icon?: React.FC;
    colors?: keyof PieColors;
    label?: string;
    iconFill?: string;
}

export const PieChartWrapper: React.FC<PieChartWrapperProps> = ({ data, testId, id, dimensions, icon, colors, label = '', iconFill }) => {
    const diameter = useMemo(() => {
        if (dimensions) {
            const svgWidth = dimensions.width - WRAPPER_PADDING;
            const svgHeight = dimensions.height - (WRAPPER_PADDING + MARKERS_HEIGHT);
            return min([svgWidth, svgHeight])!;
        }
        return 0;
    }, [dimensions]);

    const filteredData = useMemo(() => data.filter(({ value }) => value), [data]);

    const wrapperWidth = useMemo(() => !isUndefined(dimensions) && dimensions.width - WRAPPER_PADDING || 0, [dimensions]);
    const wrapperHeight = useMemo(() => !isUndefined(dimensions) && dimensions.height - (MARKERS_HEIGHT + WRAPPER_PADDING) || 0, [dimensions]);

    return (
        <div className={styles.pieChartWrapper} data-testid={`home-page-pie-chart-wrapper-${testId}`} style={{ width: `${wrapperWidth}px`, height: `${wrapperHeight}px` }}>
            <PieChart data={filteredData} testId={testId} id={id} diameter={diameter} colors={colors} />
            {icon &&
                <div
                    className={styles.pieChartIcon}
                    style={{ height: `${diameter / 3}px`, width: `${diameter / 3}px` }}
                    data-testid={`pie-chart-icon-${testId}`}
                >
                    <Icon icon={icon} fontSize={diameter / 5} fill={iconFill} />
                </div>
            }
            {label && <div className={styles.pieChartWrapperLabel}>{label}</div>}
        </div>
    );
};
